import { Box, Button, Col, H3, HorizontalRule, Row } from '@snsw/react-component-library';
import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './TopPageSummary.module.scss';

export const TopPageSummary = (props) => {
  const { item = {}, detailPropertyMap = [], titlePropertyMap = [] } = props;
  const navigate = useNavigate();

  const renderDetails = (item, itemName, detailLabelPropertyMap) => {
    let details = detailLabelPropertyMap.reduce((result, element) => {
      //if property is empty value, do not display
      if (item[itemName]?.[element.itemPropertyName]) {
        result.push(
          <Row key={element.itemPropertyName} className={styles.detailsRow}>
            <Col span={4} className={styles.detailsLabel}>
              {element.title}
            </Col>
            <Col span={6} className={styles.detailsValue}>
              {item[itemName]?.[element.itemPropertyName]}
            </Col>
          </Row>,
        );
      }
      return result;
    }, []);

    return details;
  };

  return (
    <>
      <Box style={{ marginBottom: 0 }}>
        {titlePropertyMap.map((element, index) => {
          return (
            <Fragment key={index}>
              <div className={styles.titleLine}>
                <H3 className={styles.titleLeft}>{element.title}</H3>
                <div className={styles.titleRight}>
                  <Button
                    variant={'link'}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`${element.link}`);
                    }}
                  >
                    Edit
                  </Button>
                </div>
              </div>
              {renderDetails(item, element.itemName, detailPropertyMap)}
              {index < titlePropertyMap.length - 1 && <HorizontalRule className={styles.boxSeparator} />}
            </Fragment>
          );
        })}
      </Box>
    </>
  );
};
